import { getAllTranscriptFromNotesList } from '@ax/service';
import { useQuery } from '@tanstack/react-query';

export function useGetAllTranscriptFromNoteListApi(noteIds: string[]) {
  const query = useQuery({
    queryKey: [noteIds],
    queryFn: () => getAllTranscriptFromNotesList(noteIds),
    onError: (error: Error) => {
      console.log(error.message);
    },
    enabled: !!noteIds && noteIds.length > 0,
    refetchInterval: 3000,
  });
  return query;
}
